<kendo-dialog *ngIf="opened" (close)="close()" [width]="'100%'" [height]="'100%'" style="overflow: hidden;">
	<div class="container" [ngStyle]="{'height':container_Height+'px'}" *ngIf="!noProductMessage">
		<div *ngIf="!showLoader">
			<img src="/assets/images/logowiz.png" style="height: 80px; margin-top: 10px; margin-bottom: 80px;">

			<div class="row" [ngStyle]="{'height':middel_Height+'px'}">

				<div class="card" *ngIf="!authStatus">
					<div class="card-body text-left" style="text-align: left;"
						[ngStyle]="{'height':middle_Height+'px'}">
						<app-wait [message]="'Authorizing. Please wait...'"></app-wait>
					</div>
				</div>

				<div *ngIf="authStatus">

					<div class="card">
						<div class="card-body text-left" style="text-align: left; padding-top: 10px;" [ngStyle]="{'height':middle_Height+'px'}">
							<div class="row sep">
								<div class="col col-2"></div>
								<div class="col col-8 lab" style="text-align: center; font-weight: bold;"><span i18n="Wizard|'Choose Product' label">Choose product</span></div>
							</div>
							<div class="row sep">
								<div class="col col-2"></div>
								<div class="col col-8">
									<kendo-dropdownlist style="width: 100%" [data]="products" textField="productName"
										valueField="productConfigurationId" [(ngModel)]="currentProductId"
										[valuePrimitive]="true" (valueChange)="onProductChange($event)">
									</kendo-dropdownlist>
								</div>
							</div>
							<div class="row sep" *ngIf="!isB2BCustomer">
								<div class="col col-2"></div>
								<div class="col col-2 lab"><span i18n="Wizard|'Order code' label">Order code</span>:</div>
								<div class="col col-7">
										<kendo-textbox [(value)]="orderCode" style="width: 300px" [maxlength]="16"
											[disabled]="orderCodeDisabled"></kendo-textbox>
								</div>
							</div>
							<div class="row sep" *ngIf="isB2BCustomer">
								<div class="col col-2"></div>
								<div class="col col-2"><span i18n="Wizard|'Customer ID' label">Customer ID</span>:</div>
								<div class="col col-7">
									<kendo-textbox [(value)]="clientId" [maxlength]="16" style="width: 300px"></kendo-textbox>
								</div>
							</div>
							<div class="row" style="padding-bottom: 20px;" *ngIf="isB2BCustomer && false">
								<div class="col col-2"></div>
								<div class="col col-4">
										<button kendoButton [toggleable]="true" style="width: 100%;"
											[selected]="climateZoneMode=='PostalCode'"
											(selectedChange)="climateZoneMode='PostalCode'">
											<span i18n="Wizard|'Climate zone by postal code' label">Get climate zones by postal code</span>
										</button>
								</div>
								<div class="col col-4">
										<button kendoButton [toggleable]="true" style="width: 100%;"
											[selected]="climateZoneMode=='Manual'"
											(selectedChange)="climateZoneMode='Manual'">
											<span i18n="Wizard|'Climate zone manual' label">Set climate zones manual</span>
										</button>
								</div>

							</div>
							<div class="row" *ngIf="isB2BCustomer">
								<div class="col col-2"></div>
								<div class="col col-2 lab"><span i18n="Wizard|'Postal code' label">Postal code</span>:</div>
								<div class="col col-2">
									<kendo-maskedtextbox [(value)]="zipCode" mask="00000" maskValidation="true" style="width: 100px"
										[disabled]="false"></kendo-maskedtextbox>
								</div>
								<div class="col col-2 lab"><span i18n="Common|Snow zone">Snow zone</span>:</div>
								<div class="col col-2" style="text-align: right;">
									<kendo-dropdownlist [data]="snowZoneValues" [(value)]="snowZone" [disabled]="true" style="width: 100px">
									</kendo-dropdownlist>
								</div>
							</div>
							<div class="row" *ngIf="isB2BCustomer">
								<div class="col col-6"></div>
								<div class="col col-2 lab"><span i18n="Common|Wind zone">Wind zone</span>:</div>
								<div class="col col-2" style="text-align: right;">
									<kendo-dropdownlist [data]="windZoneValues" [(value)]="windZone"
										[disabled]="true" valueField="zone" textField="label"
										[valuePrimitive]="true" style="width:100px">
									</kendo-dropdownlist>
								</div>
							</div>

							<div class="row" *ngIf="!isB2BCustomer">
								<div class="col col-2"></div>
								<div class="col col-2 lab"><span i18n="Common|Snow zone">Snow zone</span>:</div>
								<div class="col col-2">
									<kendo-dropdownlist [data]="snowZoneValues" [(value)]="snowZone" [disabled]="false" style="width: 100px">
									</kendo-dropdownlist>
								</div>
								<div class="col col-2 lab"><span i18n="Common|Wind zone">Wind zone</span>:</div>
								<div class="col col-2" style="text-align: right;">
									<kendo-dropdownlist [data]="windZoneValues" [(value)]="windZone"
										[disabled]="false" valueField="zone" textField="label"
										[valuePrimitive]="true" style="width:100px">
									</kendo-dropdownlist>
								</div>
							</div>
						</div>
					</div>


					<app-wait [show]="showLoading" [message]="loadingMessage"></app-wait>


					<div class="row wizzard-nav" [ngStyle]="{'height':bottom_Height+'px'}">
						<div>
							<button kendoButton primary="true" fillMode="outline"
								style="width: 200px; margin-top: 40px;"
								(click)="start()" [disabled]="!isValid()"
								i18n="Wizard|'Start' button">
								Start >
							</button>
						</div>
					</div>
				</div>

				<div *ngIf="showLoader">
					<div [ngClass]="{'load-complete':loaderComplate,'circle-loader':showLoader}">
						<svg [ngClass]="{'animated-check':loaderComplate}" viewBox="0 0 33 33">
							<path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none" />
						</svg>
					</div>
					<p i18n="Wizard|'Project creation' label">Project creation</p>
				</div>

			</div>
		</div>
	</div>
</kendo-dialog>

<app-info-dialog [dialogOpened]="infoOpened" [dialogMessage]="infoMessage"
	(dialogClosed)="onInfoClosed()"></app-info-dialog>